import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef } from '@angular/core';
import { Contato } from 'src/app/models/contato';
import { MASKS } from 'ng-brazil';
import { Ibge } from 'src/app/models/ibge';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ContatoService } from 'src/app/services/contato.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { ViaCepService } from 'src/app/services/via-cep.service';
import { IbgeService } from 'src/app/services/ibge.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCep } from 'src/app/models/viacep';
import { Subscription } from 'rxjs';
import { Configuracao } from 'src/app/models/configuracao';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { Funcionario } from 'src/app/models/funcionario';
import { globals } from 'src/app/globals';
import { AppConfigService } from 'src/app/services/app-config.service';
import { PremissasService } from 'src/app/services/premissas.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-contato',
  templateUrl: './cadastrar-contato.component.html',
  styleUrls: ['./cadastrar-contato.component.scss']
})
export class CadastrarContatoComponent implements OnInit, OnDestroy, AfterViewInit {


  // variáveis
  contato = new Contato();
  editando = false;
  carregando = true;

  enviouContato = false;
  possuiVenda = false;

  tiposDePessoa = [{ id: 1, nome: 'FÍSICA' }, { id: 0, nome: 'JURÍDICA' }];

  public MASKS = MASKS;
  editavel = true;
  mascara = {
    guide: true,
    showMask: true,
    mask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  };
  estados = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI',
    'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'];

  estadoSelecionado = undefined;

  cidades: Ibge[] = [];
  cidadeSelcionado = undefined;
  vendedores: Funcionario[] = [];

  mostrarVendedores = false;


  customPatterns = {
    V: { pattern: new RegExp('(,|[0-9]|-|\\.)') },
    0: { pattern: new RegExp('[0-9]') }
  };

  private nativeElement: Node;
  private configuracaoSubscription$: Subscription;
  configuracao: Configuracao;

  urls = [];
  urlSelecionada = globals.apiUrl;

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService, private element: ElementRef,
    private contatoService: ContatoService, private router: Router, private carregandoService: CarregandoService,
    private globalService: GlobalService, private viaCepService: ViaCepService, private ibgeService: IbgeService,
    private utilitarioService: UtilitarioService, private funcionarioService: FuncionarioService, private appConfigService: AppConfigService,
    private premissasService: PremissasService) {
    this.nativeElement = element.nativeElement;
  }

  ngOnInit() {

    this.urls = this.appConfigService.getServerUrls();

    if (!this.urls.some(p => p === this.urlSelecionada)) {
      this.urlSelecionada = undefined;
    }

    if (this.urls.length > 0) {
      this.urlSelecionada = this.urls[0];

      globals.apiUrl = this.urlSelecionada;
      localStorage.setItem('urlApi', this.urlSelecionada);
    }

    this.contato = new Contato();
    this.contato.tipo = 0;

    this.atualizaDadosContato();

    // inscreve no evento de troca de configuração
    this.configuracaoSubscription$ = this.globalService.alterouConfiguracao.subscribe(conf => {
      this.configuracao = conf;
    });

    const body = document.getElementsByTagName('body')[0];
    body.classList.add('login-page');
    body.classList.add('off-canvas-sidebar');
    const card = document.getElementsByClassName('card')[0];
    setTimeout(function () {
      // after 1000 ms we add the class animated to the login/register card
      card.classList.remove('card-hidden');
    }, 700);
  }

  alteraUrl() {
    globals.apiUrl = this.urlSelecionada;
    localStorage.setItem('urlApi', this.urlSelecionada);
  }

  buscarVendedores() {
    this.carregandoService.mostra('buscarVendedores');

    this.funcionarioService.consultarFuncionariosContatos().subscribe(dados => {
      this.vendedores = dados;
      this.carregandoService.esconde('buscarVendedores');
    }, (erro) => {
      this.carregandoService.esconde('buscarVendedores');
      this.notificacaoService.erro(erro);
    });
  }

  focalizaNumero() {
    $('#numero').focus();
  }

  ngAfterViewInit(): void {
    this.rodaScriptTabEnter();
  }

  rodaScriptTabEnter() {
    this.utilitarioService.rodaScriptTabEnter();
  }

  atualizaDadosContato() {
    // this.contato.dtNasc = new DatePipe('pt-BR').transform(this.contato.dtNasc, 'MM-dd-yyyy');
    // this.contato.dtAbert = new DatePipe('pt-BR').transform(this.contato.dtAbert, 'y-MM-dd');

    // this.contato.dtNasc = this.contato.dtNasc ? new Date(this.contato.dtNasc).toISOString() : undefined;
    // this.contato.dtAbert = this.contato.dtAbert ? new Date(this.contato.dtAbert).toISOString() : undefined;
    this.estadoSelecionado = this.estados.find(s => s === this.contato.uf);

    // this.tipoSelecionado = this.tipos.find(s => s === this.contato.tipo);

    this.rodaScriptTabEnter();


    this.buscarVendedores();
    this.buscarCidades();

    this.carregandoService.esconde('buscaContato');
    this.carregando = false;
  }



  salvar() {
    this.carregandoService.mostra('salvaContato');
    this.contato.uf = this.estadoSelecionado;
    this.contato.ibge = this.cidadeSelcionado;
    this.contato.cidade = this.cidades.find(s => s.cod === this.contato.ibge) ?
      this.cidades.find(s => s.cod === this.contato.ibge).cidade : '';

    this.contatoService.salvar(this.contato).subscribe(() => {
      // this.notificacaoService.sucesso('Contato salvo com sucesso!!!');
      this.carregandoService.esconde('salvaContato');
      this.enviouContato = true;

    }, (erro) => {
      this.carregandoService.esconde('salvaContato');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('login-page');
    body.classList.remove('off-canvas-sidebar');
    this.configuracaoSubscription$.unsubscribe();
  }

  buscarEnderecoPorCep() {
    this.carregandoService.mostra('buscaEnderecoPorCep');
    this.viaCepService.obterEndereco(this.contato.cep).subscribe((viaCep: ViaCep) => {

      this.contato.bairro = viaCep.bairro;
      // this.contato.compl = viaCep.complemento;
      this.contato.logradouro = viaCep.logradouro;
      this.estadoSelecionado = viaCep.uf;
      this.contato.ibge = viaCep.ibge;

      this.buscarCidades();

      this.focalizaNumero();

      this.carregandoService.esconde('buscaEnderecoPorCep');
    }, (erro) => {
      this.carregandoService.esconde('buscaEnderecoPorCep');
      this.notificacaoService.erro('Não foi possível acessar o serviço de CEP!');
    });
  }

  buscarCidades(nomeCidade?: string) {
    this.carregandoService.mostra('buscaCidades');
    this.ibgeService.consultarPorEstado(this.estadoSelecionado).subscribe((ibges: Ibge[]) => {

      this.cidades = ibges;

      if (nomeCidade) {
        this.cidadeSelcionado = this.cidades.find(s => this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) === this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())) ?
          this.cidades.find(s => this.utilitarioService.remover_acentos_espaco(s.cidade.toLowerCase().trim()) === this.utilitarioService.remover_acentos_espaco(nomeCidade.toLowerCase().trim())).cod : undefined;
      }
      else {
        this.cidadeSelcionado = this.cidades.find(s => s.cod === this.contato.ibge) ?
          this.cidades.find(s => s.cod === this.contato.ibge).cod : undefined;
      }
      this.carregandoService.esconde('buscaCidades');
    }, (erro) => {
      this.carregandoService.esconde('buscaCidades');
    });
  }

  voltar() {
    this.router.navigate(['/login']);
  }

  buscarDadosCNPJ() {
    /*
    this.carregandoService.mostra('buscarDadosCNPJ');
    this.receitaService.consultaCNPJ(this.contato.cnpj)
      .subscribe((dados: DadosCNPJ) => {

        if (dados.status === 'ERROR') {
          this.notificacaoService.erro(dados.message);
        }
        else {
          const extrairPrimeiroTelefone = (valor: string): string => {
            if (!valor) return "";

            const somenteNumeros = valor.replace(/\D/g, "");

            return somenteNumeros.substring(0, 11);
          };

          this.contato.razao = dados.nome;
          this.contato.fantasia = dados.fantasia ? dados.fantasia : dados.nome;
          this.contato.telefone = extrairPrimeiroTelefone(dados.telefone);
          this.contato.email = dados.email;

          this.contato.nume = dados.numero;
          this.contato.cep = dados.cep;
          this.contato.bairro = dados.bairro;
          this.contato.comp = dados.complemento;
          this.contato.logradouro = dados.logradouro;
          this.estadoSelecionado = dados.uf;
          this.contato.ibge = undefined;

          this.buscarCidades(dados.municipio);
        }
        this.carregandoService.esconde('buscarDadosCNPJ');
      }, (erro) => {
        this.carregandoService.esconde('buscarDadosCNPJ');
        this.notificacaoService.erro('Não foi possível acessar o serviço da Receita!');
      });
     */
  }

  buscarMostrarVendedores() {
    this.carregandoService.mostra('buscarMostrarVendedores');
    this.premissasService.consultarMostrarVenContato().subscribe(f => {
      this.mostrarVendedores = f.valor;
      this.carregandoService.esconde('buscarMostrarVendedores');
    }, (erro) => {
      this.carregandoService.esconde('buscarMostrarVendedores');
      this.notificacaoService.erro(erro);
    });
  }
}
